import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled';

import { currentRmaState } from 'state/atoms';
import { ButtonPrimary, StartRmaModal } from 'components';

const SearchStyled = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 3.55rem;
`;

const Title = styled.span`
  font-size: 1.15rem;
  margin-right: 3.55rem;
  white-space: nowrap;
`;

const StartNewRma = () => {
  const currentRma = useRecoilValue(currentRmaState);
  const history = useHistory();
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const handleStartNew = () => {
    if (currentRma.items.length) {
      setIsConfirmationModalOpen(true);
    } else {
      history.push('/cases/new/search');
    }
  };

  return (
    <SearchStyled>
      <Title>Search for an existing RMA or start a new one</Title>
      <ButtonPrimary onClick={handleStartNew}>Start New RMA</ButtonPrimary>
      <StartRmaModal
        isOpen={isConfirmationModalOpen}
        onClose={() => setIsConfirmationModalOpen(false)}
      />
    </SearchStyled>
  );
};

export { StartNewRma };
